import { render } from "./NewsDetil.vue?vue&type=template&id=42bb541d&scoped=true"
import script from "./NewsDetil.vue?vue&type=script&lang=js"
export * from "./NewsDetil.vue?vue&type=script&lang=js"

import "./NewsDetil.vue?vue&type=style&index=0&id=42bb541d&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/prodbqwjw/sy-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bb541d"]])

export default __exports__